export function fetchPrintUrl(url, body) {
  return fetch(url, {
    method: 'POST',
    body,
    'Content-Type': 'application/x-www-form-urlencoded',
    mode: 'no-cors',
  })
}
